import OktaAuth from "@okta/okta-auth-js";
import { getConfig } from "../config";
import { getBearerToken } from "./index";

export var discussionGroups: any[] = [];

function discussionsServiceURL(urlSuffix: string, prefix: string = 'v1'): string {
  const config = getConfig();
  return `${config.apiBaseUrl}/discussions/${prefix}${urlSuffix}`;
}

function getDiscussionsServiceAuthHeaders(okta?: OktaAuth): { [key: string]: string } {
  return {
    'x-okta-auth': getBearerToken(okta)
  };
}

export interface DiscussionGroup {
  id: string,
  topic: string,
  count: number,
}

export async function fetchDiscussionGroups(okta?: OktaAuth): Promise<DiscussionGroup[]> {
  const resp = await fetch(discussionsServiceURL(`/discussion-groups`), {
    method: 'GET',
    headers: getDiscussionsServiceAuthHeaders(okta),
  });
  const data: { discussionGroups: DiscussionGroup[] } = await resp.json();
  discussionGroups = data.discussionGroups;
  return discussionGroups as DiscussionGroup[];
}

export async function countPots(okta?: OktaAuth, discussionGroupId: string = ""): Promise<number> {
  const resp = await fetch(discussionsServiceURL(`/posts/count?discussionGroupId=${discussionGroupId}`), {
    method: 'GET',
    headers: getDiscussionsServiceAuthHeaders(okta)
  });
  const data: { count: number } = await resp.json();
  return data?.count || 0;
}


export async function createPost(post: any, okta?: OktaAuth) {
  const resp = await fetch(discussionsServiceURL(`/posts?`), {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...getDiscussionsServiceAuthHeaders(okta)
    },
    body: JSON.stringify({
      ...post,
    })
  });
  const data = await resp.json();
  return data;
}

export async function fetchPosts(okta?: OktaAuth, discussionGroupId: string = '', parentId: string|null = null) {
  const parentIdQueryParam = parentId ? `&parentId=${parentId}` : '';
  const resp = await fetch(discussionsServiceURL(`/posts?discussionGroupId=${discussionGroupId}${parentIdQueryParam}`), {
    method: 'GET',
    headers: getDiscussionsServiceAuthHeaders(okta),
  });
  const data: any = await resp.json();
  return data.replies;
}

export async function findPost(okta: OktaAuth, id: string) {
  const resp = await fetch(discussionsServiceURL(`/posts/${id}`), {
    method: 'GET',
    headers: getDiscussionsServiceAuthHeaders(okta),
  });
  const data: any = await resp.json();
  return resp.ok ? data : null;
}

export async function paginatePosts(okta?: OktaAuth, discussionGroupId: string = '', count: number = 10, cursor: string | null = null) {
  try {
    const resp = await fetch(discussionsServiceURL(`/posts?discussionGroupId=${discussionGroupId}&count=${count}${cursor ? '&cursor=' + cursor : ''}`, 'v2'), {
      method: 'GET',
      headers: getDiscussionsServiceAuthHeaders(okta),
    });
    const data: any = await resp.json();
    return data;
  } catch (e) {
    console.error(e);
    return {
      current: {},
      results: []
    }
  }
}
